export default __webpack_public_path__ + "static/media/bg3.395ef288.png";